import Header from "../components/Header";
import styles from "../styles/AboutMe.module.css";
import software from "../resources/assets/software.webp";

const AboutMe = () => {
  return (
    <div className={styles.container}>
      <Header title="About Omar" subtitle="Hi, I'm Omar!" />
      <img src={software} alt="Software" className={styles.image} />
      <div className={styles.content}>
        <p className={styles.text}>
          Welcome to my corner of the internet! I'm someone who thrives on curiosity and creativity, blending my love for electronics, software, mechanics, and robotics.
        </p>
        <p className={styles.text}>
          Since I was a kid, I’ve been captivated by the "how" and "why" behind things, and that passion grew into exploring the vast possibilities of technology. Whether it’s designing innovative solutions, tinkering with mechanical systems, or diving into robotics experiments, I love pushing the boundaries of what’s possible.
        </p>
        <p className={styles.text}>
          This is my space to share that journey—my ideas, experiments, and passion projects. Thanks for stopping by!
        </p>
      </div>
      <footer className={styles.footer}>Made with curiosity and a love for green 🌿</footer>
    </div>
  );
};

export default AboutMe;
